import React, { useRef, useState, useEffect, useContext } from 'react';
import { motion } from "framer-motion";
import { Row, Col, Container, Modal } from "react-bootstrap";
import Cookies from 'js-cookie';
import Loader from "../NavBar/Loader/Loader.jsx";
import CollapsibleSection from '../CollapsibleSection/CollapsibleSection';
import AnnotationHelper from '../../helpers/AnnotationHelper';
import { loadingContext, loginContext } from '../../Context';
import EmotionModelHandler from '../../helpers/EmotionModelHandler'; 
import MongoRequestHandler from '../../helpers/MongoRequestHandler';
import { EmotionPredictionTable, EmotionPredictionList } from '../PredictionResultTable/PredictionResultTable';
import ImageGalleryModal from '../Modals/ImageGalleryModal.jsx';
import StudyConfirmationModal from '../Modals/CompleteStudyModal.jsx';
import CropModal from '../CropModal/CropModal.jsx';
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import write_ai from "../../images/learning_ai.png"

const startJoyRide = () => {
    const driverObj = driver({
        showProgress: true,
        popoverClass: 'driverjs-theme',
        steps: [
            { element: '.start-camera-button',  popover: { title: 'Start Camera', description: 'Click on the Start Camera button to start the camera stream on your device!', side: "top", align: 'start' }},
            { element: '.capture-photo-button', popover: { title: 'Capture Photo', description: 'Click on the Capture Photo button to capture a photo for recognition!', side: "top", align: 'start' }},
            { element: '.process-image-button', popover: { title: 'Process Image', description: 'Then, click on the Process Image button to send your captured photo to the backend for recognition!', side: "top", align: 'start' }},
            { element: '.upload-image-button', popover: { title: 'Upload Image', description: 'Friendly reminder, you can also upload images from your local machine for recognition!', side: "top", align: 'start' }},
            { element: '.select-from-gallery-button', popover: { title: 'Select From Our Samples', description: 'Or, you can select sample images from your our database!', side: "top", align: 'start' }},
            { element: '.restart-tour-button', popover: { title: 'Restart Tour', description: 'Friendly reminder, you can also click on the Restart Tour button to restart the guided tour!', side: "top", align: 'start' }},
            { popover: { title: 'Enjoy EmoAI!', description: 'That\'s it! Go ahead and start enjoying playing with EmoAI!' }}
        ]
    });

    driverObj.drive();
    
    // prevent the tour from showing again after the user has completed it
    Cookies.set('is_tour_complete', 'true', { expires: 7 });
};

const StudyTwo = () => {
    const PROCESSING_HISTORY_SOURCE = 'study_two';
    const IMAGE_SIZE_LIMIT = 3 * 1024 * 1024; // 3 MB in bytes
    const fileInputRef = useRef(null);
    const imageInputRef = useRef(null);
    const imageCanvasRef = useRef(null);
    const eraseAnnotationButtonRef = useRef(null);
    const annotationHelperRef = useRef(null);
    const cameraStreamRef = useRef(null);
    const drawButtonRef = useRef(null);
    const blurButtonRef = useRef(null); 

    const videoRef = useRef(null);
    const [isCameraOn, setIsCameraOn] = useState(false);

    const originalImageRef = useRef(null);
    const annotatedImageRef = useRef(null);
    const gradCamImageRef = useRef(null);
    const guidedGradCAMImageRef = useRef(null);

    const [drawingWidth, setDrawingWidth] = useState(25);
    const [noiseIntensity, setNoiseIntensity] = useState(50);
    const [noiseType, setNoiseType] = useState("gaussian");
    const [emotionResults, setEmotionResults] = useState([]);

    const loadingCtx = useContext(loadingContext);
    const isLoading = loadingCtx.state.isLoading;
    const [isErrorLoadingHistory, setIsErrorLoadingHistory] = useState(false);

    const loginCtx = useContext(loginContext);
    const isLoggedIn = loginCtx.state.isLoggedIn;
    const [processingHistory, setProcessingHistory] = useState([]);
    
    const [showGalleryModal, setShowGalleryModal] = useState(false); 
    const [showCompleteStudyModal, setShowCompleteStudyModal] = useState(false);

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState('');
    const [errorModalTitle, setErrorModalTitle] = useState('');

    const [refreshHistory, setRefreshHistory] = useState(true);
    const [showCropModal, setShowCropModal] = useState(false);
    const [imageSrc, setImageSrc] = useState('');

    // drawing mode can only be 'draw' or 'blur'
    const [currentDrawingMode, setCurrentDrawingMode] = useState('draw');
    const [showTooltip1, setShowTooltip1] = useState(false);
    const [showTooltip2, setShowTooltip2] = useState(false);

    const enableDrawingModeSelection = true;
    const enableBlurModeSelection = false;
    const [isAzureOnline, setIsAzureOnline] = useState(false);
  
    const handleMouseEnter1 = () => {
      setShowTooltip1(true);
    };
  
    const handleMouseLeave1 = () => {
      setShowTooltip1(false);
    };
  
    const handleMouseEnter2 = () => {
      setShowTooltip2(true);
    };
  
    const handleMouseLeave2 = () => {
      setShowTooltip2(false);
    };
    

    const handleCropComplete = (croppedImageUrl) => {
        if (imageInputRef.current && imageCanvasRef.current) {
            // Update the image source with the cropped image
            imageInputRef.current.src = croppedImageUrl;
    
            // Reset the canvas dimensions to match the new image
            const img = new Image();
            img.onload = () => {
                const canvas = imageCanvasRef.current;
                canvas.width = img.width;
                canvas.height = img.height;
    
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(img, 0, 0, img.width, img.height);
    
                // Reset the AnnotationHelper with the new image and canvas
                if (annotationHelperRef.current) {
                    annotationHelperRef.current = new AnnotationHelper(
                        canvas,
                        imageInputRef.current,
                        eraseAnnotationButtonRef.current,
                        drawingWidth
                    );
                    annotationHelperRef.current.enableAnnotation();
                    annotationHelperRef.current.setDrawingMode(currentDrawingMode);
                }
            };
            img.src = croppedImageUrl;
        }
    };

    const handleShowErrorModal = (isShow, title, message) => {
        setShowErrorModal(isShow);
        if (title) setErrorModalTitle(title);
        if (message) setErrorModalMessage(message);
    };
    

    const uploadImageOnClick = () => {
        fileInputRef.current.click();
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > IMAGE_SIZE_LIMIT) {
            handleShowErrorModal(true, 'Error', 'File size exceeds the maximum 3 MB limit. Please select a smaller file.');
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            if (imageInputRef.current) {
                imageInputRef.current.src = e.target.result;
                setImageSrc(e.target.result);
            }

            if (imageCanvasRef.current) {
                const canvas = imageCanvasRef.current;
                const ctx = canvas.getContext('2d');
                const image = new Image();
                image.src = e.target.result;
                image.onload = () => {
                    canvas.width = image.width;
                    canvas.height = image.height;
                    ctx.drawImage(image, 0, 0);
                    
                    if (annotationHelperRef.current) {
                        annotationHelperRef.current = new AnnotationHelper(
                            canvas,
                            imageInputRef.current,
                            eraseAnnotationButtonRef.current,
                            drawingWidth
                        );
                        annotationHelperRef.current.enableAnnotation();
                        annotationHelperRef.current.setDrawingMode(currentDrawingMode);
                    }
                };
            }
        };

        reader.readAsDataURL(file);
    };

    const handleDrawingWidthChange = (event) => {
        const newValue = event.target.value;
        setDrawingWidth(newValue);
        if (annotationHelperRef.current) {
            annotationHelperRef.current.ctx.lineWidth = newValue;
        }
    };

    const handleNoiseIntensityChange = (event) => {
        const newValue = event.target.value;
        setNoiseIntensity(newValue);
    };

    const handleNoiseTypeChange = (event) => {
        const newValue = event.target.value;
        setNoiseType(newValue);
    };

    const initializeAnnotationHelper = () => {
        if (imageCanvasRef.current && imageInputRef.current && eraseAnnotationButtonRef.current && drawingWidth) {
            annotationHelperRef.current = new AnnotationHelper(
                imageCanvasRef.current,
                imageInputRef.current,
                eraseAnnotationButtonRef.current,
                drawingWidth
            );
            annotationHelperRef.current.enableAnnotation();
            annotationHelperRef.current.setDrawingMode(currentDrawingMode);
        }
    };

    const fetchStatusAndInitialize = async () => {
        try {
            const status = await new EmotionModelHandler().testServerStatus();
            setIsAzureOnline(status);
        } catch (error) {
            console.error("Failed to check Azure status:", error);
            setIsAzureOnline(false);
        }
    };

    useEffect(() => {
        initializeAnnotationHelper();
        fetchStatusAndInitialize();
        if (Cookies.get('is_tour_complete') !== 'true') {
            startJoyRide();
        }
    }, []);

    // mode can be either 'blur' or 'draw'
    const handleDrawingModeChange = (mode) => {
        if (annotationHelperRef.current) {
            // Use setDrawingMode from AnnotationHelper to switch between modes
            annotationHelperRef.current.setDrawingMode(mode);

            setCurrentDrawingMode(mode);
    
            console.log("Changed drawing mode to", mode);
        }
    };

    useEffect(() => {
        if (isCameraOn) {
            startCamera();
        } else {
            stopCamera();
        }
    }, [isCameraOn]);

    useEffect(() => {
        if (isLoggedIn && refreshHistory) {
            setIsErrorLoadingHistory(false);
            loadingCtx.dispatch({ type: "on" });
            new MongoRequestHandler().fetchProcessHistory(loginCtx.state.username, PROCESSING_HISTORY_SOURCE)
                .then((data) => {
                    setProcessingHistory(data);
                    setRefreshHistory(false);
                    loadingCtx.dispatch({ type: "off" });
                })
                .catch((error) => {
                    console.error('Error loading processing history:', error);
                    setIsErrorLoadingHistory(true);
                    loadingCtx.dispatch({ type: "off" });
                });
        }
    }, [isLoggedIn, refreshHistory]);

    const startCamera = () => {
        navigator.mediaDevices.getUserMedia({ video: true })
            .then((stream) => {
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                    videoRef.current.play();

                    // Store the stream so we can access it later for proper turn off
                    cameraStreamRef.current = stream;
                }
            })
            .catch((err) => {
                console.error("Error accessing camera: ", err);
            });
    };
    
    const stopCamera = () => {
        // Stop all media tracks from the cameraStreamRef
        if (cameraStreamRef.current) {
            cameraStreamRef.current.getTracks().forEach((track) => {
                if (track.readyState === 'live' && track.kind === 'video') {
                    track.stop();  // Stops the camera hardware
                }
            });
        }
    
        // Clear the video element's source
        if (videoRef.current) {
            videoRef.current.srcObject = null;
        }
    
        // Clear the reference to the stream
        cameraStreamRef.current = null;
    };

    const capturePhoto = () => {
        if (!videoRef.current)
            return;

        // Set the canvas dimensions explicitly
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
    
        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;

        // horizontally flip the photo taken from the camera feed
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);

        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    
        const imageData = canvas.toDataURL('image/png');

        if (imageInputRef.current && imageCanvasRef.current) {
            setImageSrc(imageData);
            imageInputRef.current.src = imageData;

            const img = new Image();
            img.onload = () => {
                const canvas = imageCanvasRef.current;
                canvas.width = img.width;
                canvas.height = img.height;
    
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(img, 0, 0, img.width, img.height);
    
                // Reset the AnnotationHelper with the new image and canvas
                if (annotationHelperRef.current) {
                    annotationHelperRef.current = new AnnotationHelper(
                        canvas,
                        imageInputRef.current,
                        eraseAnnotationButtonRef.current,
                        drawingWidth
                    );
                    annotationHelperRef.current.enableAnnotation();
                    annotationHelperRef.current.setDrawingMode(currentDrawingMode);
                }
            };

            img.src = imageData;
        }

        setIsCameraOn(false);
    };


    const processImageButton = async () => {
        if (!annotationHelperRef.current && !fileInputRef.current.files.length) {
            handleShowErrorModal(true, 'Error', 'No image has been uploaded yet.');
            return;
        }
    
        const emoHelper = new EmotionModelHandler(isAzureOnline);
        const mongoHelper = new MongoRequestHandler();
        const loggedInUser = loginCtx.state.username;
    
        const maskCoordinates = annotationHelperRef.current.getDrawnArea();
        console.log("maskCoordinates", maskCoordinates)
        const canvasSize = annotationHelperRef.current.getCanvasSize();
    
        loadingCtx.dispatch({ type: "on" });
    
        const formData = new FormData();
        if (imageInputRef.current.src || fileInputRef.current.files.length === 0) {
            const blob = await fetch(imageInputRef.current.src).then(r => r.blob());
            formData.append('image', blob, 'captured.png');
        } else {
            formData.append('image', fileInputRef.current.files[0]);
        }
        
        formData.append('mask_coordinates', JSON.stringify(maskCoordinates.blurModeArea));
        formData.append('draw_coordinates', JSON.stringify(maskCoordinates.drawModeArea));
        formData.append('canvas_size', JSON.stringify(canvasSize));
        formData.append('noise_type', noiseType);
        formData.append('noise_intensity', noiseIntensity);
    
        try {
            const responseData = await emoHelper.processImage(formData);
            const { original, masked_image, gradcam_image, guided_gradcam_image, results } = responseData;
            const emoPredResult = emoHelper.extractAndSortEmotionOutputs(results);

            const historyData = {
                username: loggedInUser,
                input_image: `data:image/png;base64,${original}`,
                annotated_image: `data:image/png;base64,${masked_image}`,
                gradcam: `data:image/png;base64,${gradcam_image}`,
                guided_gradcam: `data:image/png;base64,${guided_gradcam_image}`,
                emo_pred: emoPredResult,
                history_source: PROCESSING_HISTORY_SOURCE
            };

            originalImageRef.current.src = historyData.input_image;
            annotatedImageRef.current.src = historyData.annotated_image;
            gradCamImageRef.current.src = historyData.gradcam;
            guidedGradCAMImageRef.current.src = historyData.guided_gradcam;

            setEmotionResults(emoPredResult);
            mongoHelper.handleInsertHistory(historyData).then(setRefreshHistory(true));
                
        } catch (error) {
            console.error('Error processing the image:', error);
        }
    
        loadingCtx.dispatch({ type: "off" });
    };

    const handleGalleryImageSelect = (image) => {
        // Set the imageSrc for the crop modal
        if (imageInputRef.current) {
            imageInputRef.current.src = image.src;
            setImageSrc(image.src);
        }
        setShowGalleryModal(false);
    };

    const [showIconExampleModal, setShowIconExampleModal] = useState(false);


    return (
        <div className="content">
            <div className="tabcontent">
                <h3 className='text' style={{ textAlign: "center", paddingTop: "1.25rem" }}>Let's explore Emotion AI!
                <img 
                    src={write_ai} 
                    alt="info icon" 
                    onClick={() => setShowIconExampleModal(true)}
                    style={{ width: "80px", height: "80px", marginLeft: "10px", cursor: "pointer", verticalAlign: "middle" }}
                />
                </h3>
                <Modal
                    show={showIconExampleModal}
                    onHide={() => setShowIconExampleModal(false)}
                    centered
                    size="xl"  
                    dialogClassName="custom-modal-width" 
                    >
                    <Modal.Header closeButton>
                        <Modal.Title>Sample Answers</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ textAlign: "center" }}>
                        <div style={{ overflowX: "auto" }}>
                        <table
                            style={{
                            width: "100%",
                            maxWidth: "100%",
                            borderCollapse: "collapse",
                            fontFamily: "Arial, sans-serif"
                            }}
                        >
                            <caption
                            style={{
                                captionSide: "top",
                                textAlign: "left",
                                fontSize: "1.5rem",
                                fontWeight: "bold",
                                marginBottom: "0.5rem"
                            }}
                            >
                            I tried my own face.......
                            </caption>
                            <thead>
                            <tr style={{ backgroundColor: "#f9f9f9" }}>
                                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                                What are your <span style={{ color: "blue" }}>name(s) and emotion(s)?</span>
                                </th>
                                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                                What emotion did you try to express?
                                </th>
                                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                                Did you edit the image? <br /> If yes, what did you do?
                                </th>
                                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                                What emotion(s) did AI predict?
                                </th>
                                <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                                Rate the accuracy of the predictions on a scale of{" "}
                                <span style={{ color: "blue" }}>1 (totally inaccurate)</span> to{" "}
                                <span style={{ color: "blue" }}>5 (totally accurate)</span> and explain why you chose this rating
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td style={{ border: "1px solid #ccc", padding: "8px" }}>Xingyu, Netural</td>
                                <td style={{ border: "1px solid #ccc", padding: "8px" }}> Happy </td>
                                <td style={{ border: "1px solid #ccc", padding: "8px" }}>I painted a hat </td>
                                <td style={{ border: "1px solid #ccc", padding: "8px" }}>comtempt</td>
                                <td style={{ border: "1px solid #ccc", padding: "8px" }}> <strong style={{color:'blue'}}>2</strong>,  I don’t think the AI considered my full facial expression — it only looked at certain parts, which is possible, but not accurate.</td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </Modal.Body>
                    </Modal>

                <Container className='custom-container'>
                    <Row>
                        <Col>
                            <CollapsibleSection collapsedContent="CONTROLS" openByDefault={false} cookiePreventState={"user_collapsed_instruction"} fixed={true} enableHover={false}>
                                <div>
                                    <motion.button
                                        type="button"
                                        className="col button restart-tour-button me-3"
                                        title="Restart Tour"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        onClick={startJoyRide}
                                    >
                                        <span className="text">Restart Tour</span>
                                    </motion.button>
                                    <motion.button
                                        type="button"
                                        className="col button button-danger me-2"
                                        title="Complete Current Session"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        onClick={() => setShowCompleteStudyModal(true)}
                                    >
                                        Complete Session
                                    </motion.button>
                                </div>
                            </CollapsibleSection>
                        </Col>
                    </Row>
                </Container>

                <Container className='custom-container'>
                    <Row className="message-card">
                        <Col xs={12} sm={6}>
                            <Row className="annotation-controls-container">
                                <Col xs={12} sm={6} md={4} lg={3}>
                                    <div className='annotation-controls'>
                                        <motion.button
                                            type="button"
                                            className="button annotation-control-btn"
                                            title="Clear drawing"
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.8 }}
                                            id="clearAnnotationButton"
                                            ref={eraseAnnotationButtonRef}
                                        >
                                            <i className='bx bx-eraser control-button-icon' />
                                            <div className="text control-button-text">Clear</div>
                                        </motion.button>
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={3}>
                                    <div className='annotation-controls'>
                                        <div className="text">Drawing Width</div>
                                        <input type="range" min="1" max="100" id="drawingWidthInput" value={drawingWidth} onChange={handleDrawingWidthChange}/>
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={3}>
                                    <div className={`annotation-controls ${currentDrawingMode === 'blur' ? '' : 'toHide'}`}>
                                        <div className="text">Blur Intensity</div>
                                        <input type="range" min="1" max="100" id="noiseIntensityInput" value={noiseIntensity} onChange={handleNoiseIntensityChange} />
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={3}>
                                    {/* <div className={`annotation-controls ${currentDrawingMode === 'blur' ? '' : 'toHide'}`}> */}
                                    <div className={`annotation-controls toHide`}>
                                        <div className="text">Blur Type</div>
                                        <select className="form-select" aria-label="select" label="Noise Type" id="noiseTypeInput" value={noiseType} onChange={handleNoiseTypeChange}>
                                            <option value="gaussian">Gaussian Noise</option>
                                            {/* <option value="local_enhancement">Local Enhancement</option> */}
                                            <option value="random">Random Noise</option>
                                            <option value="bilateral">Bilateral Blur</option>
                                        </select>
                                    </div>
                                </Col>
                            </Row>
                            <div id="imageLayerContainer">
                                <CollapsibleSection collapsedContent="" openByDefault={false} cookiePreventState={"user_collapsed_instruction"} fixed={false} enableHover={true} overlay={true} expandIcon="⌘">
                                    <motion.button
                                        type="button"
                                        className="col button annotation-control-btn me-2"
                                        title="Crop Image"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        onClick={() => setShowCropModal(true)} // Open crop modal
                                    >
                                        <i className='bx bx-crop control-button-icon' />
                                        <div className="text control-button-text">Crop</div>
                                    </motion.button>
                                    {enableDrawingModeSelection &&
                                        <motion.button
                                            type="button"
                                            ref={drawButtonRef}
                                            className="col button annotation-control-btn me-2"
                                            title="Black Out Area"
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.8 }}
                                            onClick={() => handleDrawingModeChange('draw')}
                                        >
                                            <i className={`bx control-button-icon ${currentDrawingMode === 'draw' ? 'bxs-pen active': 'bx-pen'}`}/>
                                            <div className="text control-button-text">Draw</div>
                                        </motion.button>
                                    }
                                    {enableBlurModeSelection && 
                                        <motion.button
                                            type="button"
                                            ref={blurButtonRef}
                                            className="col button annotation-control-btn me-2"
                                            title="Blur Area"
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.8 }}
                                            onClick={() => handleDrawingModeChange('blur')}
                                        >
                                            <i className={`bx control-button-icon ${currentDrawingMode === 'blur' ? 'bxs-brush active': 'bx-brush'}`}/>
                                            <div className="text control-button-text">Blur</div>
                                        </motion.button>
                                    }
                                </CollapsibleSection>
                                <img id="imageInput" ref={imageInputRef} />
                                <canvas id="imageCanvas" ref={imageCanvasRef} />
                                {isCameraOn && <video ref={videoRef} id="videoOverlay" />}
                            </div>

                            <Container>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />

                                <Row style={{ gap: "0.25rem" }}>
                                    <motion.button
                                        type="button"
                                        className="col button start-camera-button"
                                        title="Start Camera"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        onClick={() => {
                                            setIsCameraOn(prev => !prev);
                                        }}
                                    >
                                        {isCameraOn ? <i className='bx bx-video-off control-button-icon' /> : <i className='bx bx-video control-button-icon' />}
                                        <span className="text control-button-text">Video</span>
                                    </motion.button>
                                    {isCameraOn && 
                                        <motion.button
                                            type="button"
                                            className="col button capture-photo-button"
                                            title="Capture Photo"
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.8 }}
                                            id="uploadImageButton"
                                            onClick={capturePhoto}
                                        >
                                            <i className='bx bx-camera control-button-icon' />
                                            <span className="text control-button-text">Capture</span>
                                        </motion.button>
                                    }
                                    <motion.button
                                        type="button"
                                        className="col button upload-image-button"
                                        title="Upload Image"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        id="uploadImageButton"
                                        onClick={uploadImageOnClick}
                                    >
                                        <i className='bx bx-upload control-button-icon' />
                                        <span className="text control-button-text">Upload</span>
                                    </motion.button>

                                    <motion.button
                                        type="button"
                                        className="col button select-from-gallery-button"
                                        title="Restart Tour"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        onClick={ () => setShowGalleryModal(true) }
                                    >
                                        <i className='bx bx-photo-album control-button-icon' />
                                        <span className="text control-button-text">Gallery</span>
                                    </motion.button>
                                    <motion.button
                                        type="button"
                                        className="col button process-image-button ms-4"
                                        title="Process Image"
                                        whileHover={{ scale: 1.05 }}
                                        whileTap={{ scale: 0.8 }}
                                        onClick={processImageButton}
                                        disabled={isLoading ? true : false}
                                    >
                                        <i className='bx bx-paper-plane control-button-icon'  />
                                        <span className="text control-button-text" >Process</span>
                                    </motion.button>
                                </Row>
                            </Container>

                            <div id="error-message" className="error-message"></div>
                        </Col>

                        <Col xs={12} sm={6}>
                            <h4 className="text">{isLoading ? "Processing..." : "Results"}</h4>
                            {
                                isLoading ? 
                                <Loader /> 
                                :
                                <>
                                    <EmotionPredictionTable predictions={emotionResults} />
                                    {emotionResults.length > 0 && (
                                        <p className="highlight sentence">
                                            AI might make mistakes. It is okay if you disagree with it.
                                        </p>
                                    )}
                                </>
                            }
                            
                        </Col>
                    </Row>

                    <Row className="message-card" >
                        <h4 className="text">Visualizations</h4>

                        <Col xs={12} sm={6} md={4} lg={3}>
                            <h5 className="text">Original</h5>
                            <img id="originalImage" className="visualization-images" ref={originalImageRef} />
                        </Col>

                        <Col xs={12} sm={6} md={4} lg={3}>
                            <h5 className="text">Annotated Image</h5>
                            <img id="annotatedImage" className="visualization-images" ref={annotatedImageRef} />
                        </Col>

                        <Col xs={12} sm={6} md={4} lg={3}>
                        <h5>
                            <span className="text">Method One</span>
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <i
                                onMouseEnter={handleMouseEnter1}
                                onMouseLeave={handleMouseLeave1}
                                className="bx bx-info-circle info-icon"
                                />
                                {showTooltip1 && (
                                <div 
                                style={{
                                    position: 'absolute',
                                    transform: 'translateY(-130%)',
                                    width: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#000000', 
                                    padding: '10px',
                                    borderRadius: '4px',
                                    fontSize: 'small',
                                    fontWeight:'lighter',
                                    transition: 'opacity 0.2s',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                  }}>
                                    Grad-Cam highlights the areas that the model generally focuses on, with clearer regions indicating higher attention 
                                    and blurrier, darker areas indicating lower attention.
                                </div>
                                )}
                            </div>
                            </h5>
                            <img id="gradCamImage" className="visualization-images" ref={gradCamImageRef} />
                        </Col>

                        <Col xs={12} sm={6} md={4} lg={3}>
                        <h5>
                            <span className="text">Method Two</span>
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <i
                                onMouseEnter={handleMouseEnter2}
                                onMouseLeave={handleMouseLeave2}
                                className="bx bx-info-circle info-icon"
                                />
                                {showTooltip2 && (
                                <div 
                                style={{
                                    position: 'absolute',
                                    transform: 'translateY(-130%)',
                                    width: '250px',
                                    backgroundColor: '#ffffff',
                                    color: '#000000', 
                                    padding: '10px',
                                    borderRadius: '4px',
                                    fontSize: 'small',
                                    fontWeight:'lighter',
                                    transition: 'opacity 0.2s',
                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                  }}>
                                    Guided Grad-Cam shows higher color saturation outlining the specific regions of interest.
                                </div>
                                )}
                            </div>
                            </h5>
                            <img id="guidedGradCAMImage" className="visualization-images" ref={guidedGradCAMImageRef} />
                        </Col>
                    </Row>


                    <Row className="message-card">
                        <h4 className="text">Process History</h4>
                        {isLoggedIn ? (
                            !isErrorLoadingHistory && processingHistory ? (
                                <>
                                    <div className="grid-container-5">
                                        <div className="grid-item">
                                            <h5 className="text">Original</h5>
                                        </div>
                                        <div className="grid-item">
                                            <h5 className="text">Annotated Image</h5>
                                        </div>
                                        <div className="grid-item">
                                            <h5 className="text">Method One</h5>
                                        </div>
                                        <div className="grid-item">
                                            <h5 className="text">Method Two</h5>
                                        </div>
                                        <div className="grid-item">
                                            <h5 className="text">Predictions</h5>
                                        </div>
                                    </div>

                                    {processingHistory.map((entry, index) => (
                                        <div className="grid-container-5" key={index}>
                                            <div className="grid-item">
                                                <img src={entry.input_image} className="visualization-images" alt="Original" />
                                            </div>
                                            <div className="grid-item">
                                                <img src={entry.annotated_image} className="visualization-images" alt="Annotated Image" />
                                            </div>
                                            <div className="grid-item">
                                                <img src={entry.gradcam} className="visualization-images" alt="GradCAM" />
                                            </div>
                                            <div className="grid-item">
                                                <img src={entry.guided_gradcam} className="visualization-images" alt="Guided GradCAM" />
                                            </div>
                                            <div className="grid-item">
                                                <EmotionPredictionList predictions={entry.emo_pred} showFirstCount={7} fontSize={0.9} maxHeight={"80%"}/>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <span>Error loading processing history, please check server</span>
                            )
                        ) : (
                            <span>Please log in to record and view your processing history</span>
                        )}
                    </Row>
                </Container>

                <Modal show={showErrorModal} onHide={() => handleShowErrorModal(false)}>
                    <Modal.Header closeButton>
                    <Modal.Title>{errorModalTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{errorModalMessage}</Modal.Body>
                    <Modal.Footer>
                        <motion.button 
                            type="button"
                            className="button carousel-button"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.8 }}
                            onClick={() => handleShowErrorModal(false)}
                        >
                            Got it!
                        </motion.button>
                    </Modal.Footer>
                </Modal>

                <ImageGalleryModal
                    show={showGalleryModal}
                    onClose={() => setShowGalleryModal(false)}
                    onImageSelect={handleGalleryImageSelect}
                    availableFor={"study_two"}
                />

                <StudyConfirmationModal
                    show={showCompleteStudyModal}
                    handleClose={() => setShowCompleteStudyModal(false)}
                    handleConfirm={() => setShowCompleteStudyModal(true)}
                    title={"Complete The Exploration Session"}
                    message={"Are you sure you want to complete the exploration session?"}
                />

                {/* CropModal Integration */}
                <CropModal
                    show={showCropModal}
                    onHide={() => setShowCropModal(false)}
                    imageSrc={imageSrc} // Pass the current image src
                    onCropComplete={handleCropComplete} // Handle the cropped image
                />

            </div>
        </div>
    );
};

export default StudyTwo;